import { useTranslation } from "react-i18next";
import type { PageEntityKind } from "./pageContext";
import { usePageEntityName } from "./pageEntityNames";

export const presentName = (name: string | undefined): string | undefined => (name?.trim() ? name : undefined);

export const useUntitledName = (): ((kind: PageEntityKind) => string) => {
  const { t } = useTranslation();
  const untitled: Record<PageEntityKind, string> = {
    contract: t("Contract without a title"),
    v2Event: t("Sourcing event without a title"),
    project: t("Project without a title"),
    need: t("Need without a title"),
    organization: t("Company without a name"),
  };
  return (kind) => untitled[kind];
};

export const useEntityTitle = (entity: { kind: PageEntityKind; id: string; name?: string } | null | undefined) => {
  const untitledName = useUntitledName();
  const knownName = presentName(usePageEntityName(entity?.id)) ?? presentName(entity?.name);
  if (!entity) return undefined;
  return knownName ?? untitledName(entity.kind);
};
